import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DailyExtraModal from './DailyExtraModal';

class DailyExtra extends Component {
  static propTypes = {
    dailyExtra: PropTypes.object.isRequired,
  };

  renderShared() {
    const { dailyExtra } = this.props;

    return (
      <div className="daily-extra--details">
        <h3>{dailyExtra.name}</h3>
        <h4>{dailyExtra.header}</h4>
        <p>{dailyExtra.body_text}</p>
      </div>
    );
  }

  renderVideo() {
    const { dailyExtra } = this.props;

    return (
      <div className="daily-extra">
        <DailyExtraModal video={dailyExtra.video} />
        <div className="daily-extra-right">
          {this.renderShared()}
        </div>
      </div>
    );
  }

  renderImage() {
    const { dailyExtra } = this.props;

    return (
      <div className="daily-extra">
        {dailyExtra.image_id && (
          <div className="daily-extra-img__wrapper">
            <div className="daily-extra-img" style={{ backgroundImage: `url(${dailyExtra.image.location})`}} />
          </div>
        )}
        <div className="daily-extra-right">
          {this.renderShared()}
          <a
            className="button"
            href={dailyExtra.button_link}
            target={dailyExtra.button_new_window ? '_blank' : '_self'}
          >
            {dailyExtra.button_text}
          </a>
        </div>
      </div>
    );
  }

  render() {
    const { dailyExtra } = this.props;

    return dailyExtra.library_video_id ? this.renderVideo() : this.renderImage();
  }
}

export default DailyExtra;



// WEBPACK FOOTER //
// ./src/subscription/courses/components/DailyExtra.js